module.exports = __webpack_public_path__ + "static/media/41.5a84c39.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/41.wav
// module id = nqz4
// module chunks = 0